import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import cx from 'classnames';

var useStyles = makeStyles(function (theme) {
  return {
    action: {
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.primary.main
      }
    },
    disabled: {
      cursor: 'not-allowed',
      color: theme.palette.text.disabled,
      '&:hover': {
        color: theme.palette.text.disabled
      }
    }
  };
});

var CustomBreadcrumbs = function CustomBreadcrumbs(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      isRtl = _ref.isRtl;

  var classes = useStyles();

  return React.createElement(
    Breadcrumbs,
    {
      separator: isRtl ? React.createElement(NavigateBeforeIcon, { fontSize: 'small' }) : React.createElement(NavigateNextIcon, { fontSize: 'small' }),
      'aria-label': 'breadcrumb'
    },
    R.addIndex(R.map)(function (_ref2, index) {
      var _cx;

      var text = _ref2.text,
          action = _ref2.action,
          isDisabled = _ref2.isDisabled;
      return React.createElement(
        Typography,
        {
          key: text + '-' + index,
          color: 'textPrimary',
          onClick: action,
          variant: 'subtitle1',
          className: cx((_cx = {}, _cx[classes.action] = R.is(Function)(action), _cx[classes.disabled] = isDisabled, _cx))
        },
        text
      );
    })(items)
  );
};

CustomBreadcrumbs.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    action: PropTypes.func,
    isDisabled: PropTypes.bool
  })),
  isRtl: PropTypes.bool
} : {};

export default CustomBreadcrumbs;